import { ListGroup } from 'react-bootstrap'
import RecordingItem from './RecordingItem'

const RecordingList = ({ recordingList }) => {
  if (!recordingList) return ''

  return (
    <>
      <ListGroup variant='flush'>
        {recordingList.map((recording, i) => (
          <RecordingItem
            recording={recording}
            key={recording.name}
            index={i}
            max={5}
          />
        ))}
      </ListGroup>
    </>
  )
}
export default RecordingList
